// @ts-nocheck
import { useEffect, useState } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/message.css'
import { ArticleTeaser } from 'components/articleLink'
import { Search } from 'components/search'
import { CopyToClipboardUrl } from 'components/copyToClipboardUrl'
import styled from 'styled-components'
import { GlobalVariables } from 'Globals/GlobalVariables'

const ARTICLE_ID = '306707382831'

const State = {
  Loading: 0,
  Ready: 1,
  Error: 2,
}

export const Collection = ({ colorMode }: { colorMode: 'dark' | 'light' }) => {
  const [readArticles, setReadArticles] = useState([])
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)
  const [requestState, setRequestState] = useState(State.Loading)
  const [teasers, setTeasers] = useState([])
  const [stories, setStories] = useState([])
  const [sectionsOrder, setSectionsOrder] = useState([])
  const sections = teasers.reduce(
    (result, item) => ({
      ...result,
      [item.section]: [...(result[item.section] || []), item],
    }),
    {}
  )

  const handleResize = () => {
    setIsMobile(window.innerWidth < 768)
  }

  const handleTeaserClick = (id) => {
    const newReadArticles = [...new Set([...readArticles, +id])]
    setReadArticles(newReadArticles)
    localStorage.setItem(ARTICLE_ID, JSON.stringify(newReadArticles))
  }

  const handleArticleLoaded = (articleData) => {
    setStories((p) => [...p, articleData])
  }

  useEffect(() => {
    if (localStorage.getItem(ARTICLE_ID)) {
      setReadArticles(JSON.parse(localStorage.getItem(ARTICLE_ID)))
    }

    fetch(
      `https://storage.googleapis.com/wch-interactive/question-verte/questions.json`
    ).then((res) => {
      return res.json().then((json) => {
        setTeasers(json.data.questions)
        setSectionsOrder(json.data.categories)
        setRequestState(State.Ready)
      })
    })

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <Wrapper>
      <div className='ui vertical segment' style={{ paddingBottom: 0 }}>
        <div className='ui text center aligned container'>
          <img
            style={{
              width: '100%',
              maxWidth: '400px',
            }}
            alt='La question verte'
            src={require('../../images/illu-test-2.png')}
          />
        </div>
      </div>

      <header
        className='ui vertical  very fitted  segment'
        style={{ paddingTop: 0 }}
      >
        <HeaderContainer colorMode={colorMode}>
          <div className='ui container'>
            <div className='ui header'>
              <h1>La question verte</h1>
              <h2>
                Nous répondons aux questions sur la thématique du climat que
                nous nous posons dans nos vies quotidiennes.
              </h2>
            </div>
            {stories.length > 0 && (
              <div className='ui ta authors'>
                Mis à jour le{' '}
                {new Date(
                  stories.sort(
                    (a, b) => b.updateDate - a.updateDate
                  )[0].updateDate
                ).toLocaleDateString('fr-CH', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                })}
              </div>
            )}
          </div>
        </HeaderContainer>
      </header>

      {requestState !== State.Ready && (
        <div className='ui vertical very fitted  segment'>
          <div className='ui center aligned text container'>
            {requestState === State.Loading && (
              <div className='ui icon message'>
                <div className='content'>
                  <i
                    style={{ fontSize: '2em' }}
                    className='notched circle loading icon'
                  />
                  <div className='header'>Encore quelques secondes</div>
                  <p>Nous cherchons les questions pour vous.</p>
                </div>
              </div>
            )}
            {requestState === State.Error && (
              <div className='ui icon message'>
                <div className='content'>
                  <div className='header'>Les questions sont introuvables</div>
                  <p>Veuillez réessayer plus tard.</p>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {requestState === State.Ready && (
        <>
          <div className='colored'>
            <div className='ui container'>
              <ArticleTeaser
                handleArticleLoaded={handleArticleLoaded}
                handleClick={handleTeaserClick}
                readArticles={readArticles}
                title='Dernières questions'
                inverted
                ids={teasers
                  .slice(teasers.length - (isMobile ? 5 : 4), teasers.length)
                  .map((t) => +t.id)}
              />
            </div>
          </div>

          <div className='ui vertical segment'>
            <div className='ui container'>
              <div className='ui message' style={{ borderRadius: '83px' }}>
                <Search ids={teasers.map((t) => +t.id)} />
              </div>
            </div>
          </div>

          <div className='ui container'>
            {sectionsOrder.map((section, index) => {
              return (
                <Section key={section.nom}>
                  {index === 3 && (
                    <CopyToClipboardUrl
                      locale='fr'
                      title='Partager la Question Verte'
                      text='Partagez les questions avec vos amis et vos connaissances!'
                      url={window.location.href}
                      buttonColor='var(--stda-main-color)'
                    />
                  )}
                  <ArticleTeaser
                    handleArticleLoaded={handleArticleLoaded}
                    handleClick={handleTeaserClick}
                    readArticles={readArticles}
                    sep
                    title={section.nom}
                    ids={sections[section.nom].map((s) => +s.id)}
                  />
                </Section>
              )
            })}
          </div>
        </>
      )}
    </Wrapper>
  )
}
export default Collection

const Wrapper = styled(GlobalVariables)`
  .ui.message {
    background-color: var(--stda-main-color);
    color: #f1e2ce;
    -webkit-font-smoothing: antialiased;
    border-radius: 20px;

    a {
      color: #f1e2ce;
      opacity: 0.65;
    }
  }

  .colored {
    background-color: var(--stda-main-color);
  }

  color: var(--stda-main-color);
  a {
    color: var(--stda-main-color);
  }

  .ui.button.primary {
    background-color: var(--stda-main-color);
  }

  header {
    text-align: center;
    padding-bottom: 2em;

    h2 {
      padding: 0;
    }

    @media only screen and (min-width: 768px) {
      padding-bottom: 4em;

      h2 {
        padding: 0 15%;
      }
    }
  }

  .index {
    width: 100%;
    height: 100%;

    canvas {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      pointer-events: none;
      overflow: hidden;
    }
  }

  .hint {
    text-align: center;
    animation: hint-animation 1s infinite;

    @keyframes hint-animation {
      0% {
        transform: translateY(-10px);
      }
      50% {
        transform: translateY(0px);
      }
      100% {
        transform: translateY(-10px);
      }
    }
  }

  .illu {
    position: absolute;
    width: 300px;
    height: 300px;
    left: 50%;
  }

  .hint-circle {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: #ffffff;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
    border: 5px solid #ffbda2;
    color: #ffbda2;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .hint-text {
    font-family: 'TamediaChart';
    font-size: 0.85em;
    display: none;
  }
`

const Section = styled.section``

const HeaderContainer = styled.div<{ colorMode: 'dark' | 'white' }>`
  font-size: 1.6rem;
  font-family: var(--font-plex);
  color: ${(props) =>
    props.colorMode === 'dark' ? 'var(--stda-light-yellow)' : 'var(--stda-main-color)'};

  .ui.header {
    h1,
    h2 {
      color: ${(props) =>
        props.colorMode === 'dark' ? 'var(--stda-light-yellow)' : 'var(--stda-main-color)'};
    }
    h1 {
      font-size: 7rem;
      line-height: 6rem;
      font-family: --var(font-noto);
      margin-bottom: 2rem;
    }
    h2 {
      font-size: 2.6rem;
      font-weight: 200;
      line-height: 1.2;
    }
  }
  .ui.ta.authors {
    font-family: var(--font-plex) !important;
  }
  margin-bottom: 2rem;
`

const FeedbackContainer = styled.div`
  .ui .list,
  .ui.message {
    font-size: 1.8rem !important;
  }
`
